/* COATY pre-launch theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  /* ---------- Countdown ---------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdown(el) {
    var target = new Date(el.getAttribute('data-target'));
    var fields = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      minutes: el.querySelector('[data-unit="minutes"]'),
      seconds: el.querySelector('[data-unit="seconds"]')
    };
    if (isNaN(target.getTime())) {
      el.setAttribute('data-state', 'invalid');
      return;
    }
    if (el._countdownTimer) clearInterval(el._countdownTimer);
    var timer;
    function tick() {
      if (!document.body.contains(el)) { clearInterval(timer); return; }
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        el.setAttribute('data-state', 'done');
        if (timer) clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (fields.days) fields.days.textContent = String(d);
      if (fields.hours) fields.hours.textContent = pad(h);
      if (fields.minutes) fields.minutes.textContent = pad(m);
      if (fields.seconds) fields.seconds.textContent = pad(s);
      el.setAttribute('data-state', 'running');
    }
    tick();
    timer = setInterval(tick, 1000);
    el._countdownTimer = timer;
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  }

  /* ---------- Form validation ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setFieldError(field, message) {
    var wrap = field.closest('.field');
    if (!wrap) return;
    var err = wrap.querySelector('.field__error');
    if (message) {
      wrap.classList.add('is-invalid');
      field.setAttribute('aria-invalid', 'true');
      if (!err) {
        err = document.createElement('p');
        err.className = 'field__error';
        err.id = field.id + '-error';
        wrap.appendChild(err);
        field.setAttribute('aria-describedby', err.id);
      }
      err.textContent = message;
    } else {
      wrap.classList.remove('is-invalid');
      field.removeAttribute('aria-invalid');
      if (err) err.remove();
    }
  }

  function msgFor(form, key) {
    var wrap = form.closest('.form-wrap');
    return wrap ? wrap.getAttribute('data-msg-' + key) : null;
  }

  function validateForm(form) {
    var valid = true;
    var first = null;
    var fields = form.querySelectorAll('input, select, textarea');
    Array.prototype.forEach.call(fields, function (field) {
      if (field.type === 'hidden' || field.disabled) return;
      var value = (field.value || '').trim();
      var msg = '';
      if (field.required && !value) msg = msgFor(form, 'required') || 'This field is required.';
      else if (field.type === 'email' && value && !EMAIL_RE.test(value)) msg = msgFor(form, 'email') || 'Enter a valid email address.';
      else if (field.type === 'url' && value && !/^https?:\/\//i.test(value)) field.value = 'https://' + value;
      setFieldError(field, msg);
      if (msg && !first) first = field;
      if (msg) valid = false;
    });
    if (first) first.focus();
    return valid;
  }

  function initForm(form) {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      if (!validateForm(form)) { e.preventDefault(); return; }
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        var sending = msgFor(form, 'sending');
        if (sending) { btn.setAttribute('data-label', btn.textContent); btn.textContent = sending; }
      }
    });
    Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (field) {
      field.addEventListener('input', function () {
        if (field.closest('.field') && field.closest('.field').classList.contains('is-invalid')) setFieldError(field, '');
      });
    });
  }

  /* Shopify posts customer/contact forms back to the page with ?customer_posted=true or
     ?contact_posted=true and the form id as the hash. Every form of the same type then renders
     the same success/error state, so we keep the notice only on the form that was submitted. */
  function scopeFormNotices() {
    var params = new URLSearchParams(window.location.search);
    var posted = params.has('customer_posted') || params.has('contact_posted') || params.has('form_type');
    var hash = window.location.hash ? window.location.hash.slice(1) : '';
    var notices = document.querySelectorAll('.notice[data-form-id]');
    if (!notices.length) return;
    Array.prototype.forEach.call(notices, function (n) {
      var id = n.getAttribute('data-form-id');
      if (hash && id !== hash) {
        n.classList.add('is-hidden');
      }
    });
    if (posted && hash) {
      var target = document.getElementById(hash);
      if (target) {
        var wrap = target.closest('.form-wrap') || target;
        wrap.scrollIntoView({ block: 'center' });
        var live = wrap.querySelector('.notice:not(.is-hidden)');
        if (live) live.focus();
      }
    }
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(details) {
    var summary = details.querySelector('summary');
    function setLabel() {
      var open = details.hasAttribute('open');
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      summary.setAttribute('aria-label', open ? summary.getAttribute('data-close') : summary.getAttribute('data-open'));
    }
    details.addEventListener('toggle', setLabel);
    setLabel();
    details.addEventListener('keydown', function (e) { if (e.key === 'Escape' && details.open) { details.removeAttribute('open'); summary.focus(); } });
    Array.prototype.forEach.call(details.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () { details.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) { if (details.open && !details.contains(e.target)) details.removeAttribute('open'); });
    window.matchMedia('(min-width: 900px)').addEventListener('change', function (mq) { if (mq.matches) details.removeAttribute('open'); });
  }

  /* ---------- Boot ---------- */
  function boot(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-countdown]'), initCountdown);
    Array.prototype.forEach.call(root.querySelectorAll('form.js-validate'), initForm);
    Array.prototype.forEach.call(root.querySelectorAll('details[data-mobile-menu]'), initMenu);
  }

  boot(document);
  scopeFormNotices();

  /* Re-run when a section is re-rendered inside the Shopify theme editor */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
